import axios from "axios";
import { url } from "../constants/constants";

import { refreshToken } from "./session";

axios.defaults.baseURL = url;

/** 401 시 한 번만 갱신 요청하고, 나머지 요청은 이 promise를 기다린 뒤 재시도 */
let refreshPromise = null;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    if (error?.response?.status === 401 && !config?.sent) {
      config.sent = true;

      if (!refreshPromise) {
        refreshPromise = refreshToken();
      }

      const result = await refreshPromise;
      refreshPromise = null;

      if (result?.accessToken) {
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${result?.accessToken}`,
        };
        return axios(config);
      }

      window.dispatchEvent(new CustomEvent("auth:sessionExpired"));
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export const axiosPrivate = axios;
